// Utilities
import { getCheckoutIdFromUrl } from 'utils/browser-url.utils';

const LOAD_STRIPE_PROPS = {
  betas: ['blocked_card_brands_beta_2'],
};

const PAYMENT_LANDING_SOCKET_MESSAGE = {
  endpoint: '/v1/checkout/orders/payment',
  payload: {
    orderId: getCheckoutIdFromUrl(),
  },
};

export { LOAD_STRIPE_PROPS, PAYMENT_LANDING_SOCKET_MESSAGE };
